















    /* eslint-disable @typescript-eslint/camelcase */ 

    import { perguntaAdminService } from '@/servicegerente' ;

    import AssuntoFormAdicionar from './_AssuntoFormAdicionar.vue';

    import $ from "jquery";


    import { Watch, Component, Vue } from 'vue-property-decorator';
      
    @Component({
        components: { 
            'assunto-form-adicionar': AssuntoFormAdicionar
        },
    })
    export default class Principal extends Vue { 

        private assuntos: any= null; 

        private pergunta: any= null; 
        
        private reloadDatatable: any= false; 

        created() {
            window.alertProcessando();
            perguntaAdminService.getPergunta(this.$route.params.id)
                .then(response => {
                    window.alertProcessandoHide();
                    this.pergunta = response;
                })
                .catch(error => {
                    window.toastErro('Não foi possivel achar o Pergunta', error.data);
                    window.alertProcessandoHide(); 
                });
 
        }
            

        private config: any= {  
            order: [  [1, "asc"] ],
            lengthMenu : [ [ -1],   [  "Todos"]  ],
            dom: '<"top"r>t<"bottom"><"clear">',
            ajax: {
                url: perguntaAdminService.getUrl() + '/' + this.$route.params.id + '/assunto/datatable'
            },
            columns: [
                {  data: 'nome', name: 'assunto.nome'  },
                { data: 'action', name: 'action', orderable: false, searchable: false, class: 'text-center' }
            ],
        };  
        
        
        assuntoAdicionado(event: any) {
            this.assuntos = event; 
            this.$emit('assuntoAlterado', event);
            this.reloadDatatable = !this.reloadDatatable;
        }


        buscarAssunto() {
            window.alertProcessando();
            perguntaAdminService.buscarAssunto(this.$route.params.id )
                .then(response => {
                    this.assuntos = response;
                    window.alertProcessandoHide();
                })
                .catch(error => {
                    window.toastErro("Não foi possivel achar os assuntos para adiocionar", error.data);
                    window.alertProcessandoHide();
                });
        }


        @Watch('pergunta')
		changePergunta(newVal: any) {
			 this.buscarAssunto();
        }
        

         public tableatualizada( ) {  

			 $('[btn-excluir]').click(  (btn) => {  
                const id =   $(btn.currentTarget).data('id');  
                window.alertConfimacao('Confirma a Exclusão ','' , 
                     () => {  
                        window.alertProcessando(); 
                        perguntaAdminService.removerAssunto( this.$route.params.id,  id )
                        .then(response => {
							window.alertProcessandoHide();  
                            this.assuntos = response;
                            this.$emit('assuntoAlterado', event);
                            this.reloadDatatable = !this.reloadDatatable; 
                            window.toastSucesso('Assunto removido com sucesso!!' ); 
                        })
                        .catch(error => { 
							this.reloadDatatable = !this.reloadDatatable; 
                            window.alertProcessandoHide();
                            // console.log(error);
                            window.toastErro('Não foi possivel remover o Assunto, ' , error.data); 
                        });  
                    }
                ); 
            });

        }




    }


 

